import React from "react";
import Page from "../Page/Page";

import "../../Styles/FreeDiscussion.css";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { useNavigate } from "react-router";

const FreeDiscussion = () => {
  const navigator = useNavigate();

  // ================================================

  return (
    <Page>
      <MobileNavBar
        text={"گفتگوی آزاد"}
        action={() => navigator("/hisstori/club")}
      />
      <div className="FreeDiscussion_wrapper">
        <div className="FreeDiscussion">
          <div
            className="News_back-arrow mobile-hidden"
            onClick={() => navigator("/hisstori/club")}
          >
            <svg
              width="8"
              height="15"
              viewBox="0 0 8 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
                fill="#ffffff"
              />
            </svg>
          </div>
          <div className="FreeDiscussion-top">
            <div className="FreeDiscussion-top-right">
              <img
                className="FreeDiscussion-top-right-img"
                src="/imgs/Blog/Action-profile.png"
              />
            </div>
            <p className="FreeDiscussion-top-center">سارا اسماعیلی</p>
            <div className="FreeDiscussion-top-left number-font">
              <p className="FreeDiscussion-top-left-time number-font">
                1401/4/02
              </p>
            </div>
          </div>
          <div className="FreeDiscussion-center">
            <div className="FreeDiscussion-center-inside">
              <p className="FreeDiscussion-center-inside-text">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت لورم
                ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت.لورم ایپسوم متن
                ساختگی با تولید سادگی نامفهوم از صنعت لورم ایپسوم متن ساختگی با
                تولید سادگی نامفهوم از صنعت.لورم ایپسوم متن ساختگی با تولید
                سادگی نامفهوم از صنعت لورم ایپسوم متن ساختگی با تولی
              </p>
              <div className="FreeDiscussion-bottom">
                <div className="FreeDiscussion-bottom-right">
                  <div className="FreeDiscussion-bottom-right-like">
                    <img
                      className="FreeDiscussion-bottom-right-like-img"
                      src="/imgs/Book/like.svg"
                    />
                    <p className="FreeDiscussion-bottom-right-like-text number-font">
                      5
                    </p>
                  </div>
                  <div className="FreeDiscussion-bottom-right-dislike">
                    <img
                      className="FreeDiscussion-bottom-right-like-img"
                      src="/imgs/Book/dislike.svg"
                    />
                    <p className="FreeDiscussion-bottom-right-like-text number-font">
                      5
                    </p>
                  </div>
                </div>
                <div className="FreeDiscussion-bottom-left">
                  <p className="FreeDiscussion-bottom-left-text">
                    بهش جواب بده
                  </p>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="9"
                      viewBox="0 0 12 9"
                      fill="none"
                    >
                      <path
                        d="M3.33105 0.4375L0.487305 3.6875L3.33105 6.9375M0.487305 3.6875H6.58105C9.83105 3.6875 11.4561 5.3125 11.4561 8.5625"
                        stroke="#09D4FF"
                        stroke-width="0.8125"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="FreeDiscussion-box-bottom">
            <div className="FreeDiscussion-box-bottom-inside">
              <div className="FreeDiscussion-top">
                <div className="FreeDiscussion-top-right">
                  <img
                    className="FreeDiscussion-top-right-img"
                    src="/imgs/Blog/Action-profile.png"
                  />
                </div>
                <p className="FreeDiscussion-top-center">سارا اسماعیلی</p>
                <div className="FreeDiscussion-top-left number-font">
                  <p className="FreeDiscussion-top-left-time number-font">
                    1401/4/02
                  </p>
                </div>
              </div>
              <div className="FreeDiscussion-center">
                <div className="FreeDiscussion-center-inside">
                  <p className="FreeDiscussion-center-inside-text">
                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت لورم
                    ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت.لورم ایپسوم
                    متن ساختگی با تولید سادگی نامفهوم از صنعت لورم ایپسوم متن
                    ساختگی با تولید سادگی نامفهوم از صنعت.لورم ایپسوم متن ساختگی
                    با تولید سادگی نامفهوم از صنعت لورم ایپسوم متن ساختگی با
                    تولی
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
export default FreeDiscussion;
